<template>
  <div class="m-0 dbozone-font bg-squidgame" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-squidgame" style="margin-bottom:1rem;">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("squidtoon.paytable.symtable_title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex flex-column nav-special-symbols">

        <div class="col-12 justify-content-center d-flex flex-row pading4">
          <div class="col-4 align-items-center d-flex pading4">
            <img class="" :src="require(`../../assets/resultGame/squidgame/symbol_8.png`)" alt="" style="width:100%" />
          </div>
          <div class="col-8 align-items-center d-flex pading4">
            <span class=" text-sub" :class="`-${lang}`" style="line-height: 1;">
              {{ $t("squidtoon.paytable.symtable_wild") }}
            </span>
          </div>

        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/squidgame/symbol_7.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`" style="line-height: 0.9;">
            {{ "5 - " + paytable[7][4] }}
            <br />{{ "4 - " + paytable[7][3] }}
            <br />{{ "3 - " + paytable[7][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/squidgame/symbol_6.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
            {{ "5 - " + paytable[6][4] }}
            <br />{{ "4 - " + paytable[6][3] }}
            <br />{{ "3 - " + paytable[6][2] }}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/squidgame/symbol_5.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
            {{ "5 - " + paytable[5][4] }}
            <br />{{ "4 - " + paytable[5][3] }}
            <br />{{ "3 - " + paytable[5][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/squidgame/symbol_4.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
            {{ "5 - " + paytable[4][4] }}
            <br />{{ "4 - " + paytable[4][3] }}
            <br />{{ "3 - " + paytable[4][2] }}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/squidgame/symbol_3.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
            {{ "5 - " + paytable[3][4] }}
            <br />{{ "4 - " + paytable[3][3] }}
            <br />{{ "3 - " + paytable[3][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/squidgame/symbol_2.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
            {{ "5 - " + paytable[2][4] }}
            <br />{{ "4 - " + paytable[2][3] }}
            <br />{{ "3 - " + paytable[2][2] }}
          </span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/squidgame/symbol_1.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
            {{ "5 - " + paytable[1][4] }}
            <br />{{ "4 - " + paytable[1][3] }}
            <br />{{ "3 - " + paytable[1][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/squidgame/symbol_0.png`)" alt="" />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
            {{ "5 - " + paytable[0][4] }}
            <br />{{ "4 - " + paytable[0][3] }}
            <br />{{ "3 - " + paytable[0][2] }}
          </span>
        </div>
      </div>

      <div class="d-flex flex-column nav-squidgame mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t('squidtoon.bonus.title') }}</h5>
        </section>
      </div>
      <div class="d-flex justify-content-center">
        <span class=" m-0 text-sub symbol-line-height bonusgame-title" :class="`-${lang}`">{{ $t('Red light Green light')
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-bonus" :src="require(`../../assets/resultGame/squidgame/symbol_9.png`)" alt="">
      </div>
      <div class="d-flex ">
        <span class=" m-0 text-sub symbol-line-height" :class="`-${lang}`">{{ $t('squidtoon.bonus.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-bonus" :src="require(`../../assets/resultGame/squidgame/bonus_button.png`)" alt="">
      </div>
      <div class="d-flex ">
        <span class=" m-0 text-sub symbol-line-height" :class="`-${lang}`">{{ $t('squidtoon.bonus.text2') }}</span>
      </div>
      <div class="d-flex flex-row p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 m-3 icon-bonus" :src="require(`../../assets/resultGame/squidgame/aeiou_0.png`)" alt="">
        <img class="mt-3 m-3 icon-bonus" :src="require(`../../assets/resultGame/squidgame/aeiou_1.png`)" alt="">
        <img class="mt-3 m-3 icon-bonus" :src="require(`../../assets/resultGame/squidgame/aeiou_2.png`)" alt="">
      </div>
      <div class="d-flex ">
        <span class=" m-0 text-sub symbol-line-height" :class="`-${lang}`">{{ $t('squidtoon.bonus.text3') }}</span>
      </div>
      <div class="d-flex justify-content-center">
        <span class=" m-0 text-sub symbol-line-height bonusgame-title" :class="`-${lang}`">{{ $t('Tug of war') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-bonus" :src="require(`../../assets/resultGame/squidgame/bonus_button.png`)" alt="">
      </div>
      <div class="d-flex ">
        <span class=" m-0 text-sub symbol-line-height" :class="`-${lang}`">{{ $t('squidtoon.bonus.text2') }}</span>
      </div>
      <div class="d-flex flex-row p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 m-3 icon-bonus" :src="require(`../../assets/resultGame/squidgame/tow_0.png`)" alt="">
        <img class="mt-3 m-3 icon-bonus" :src="require(`../../assets/resultGame/squidgame/tow_1.png`)" alt="">
        <img class="mt-3 m-3 icon-bonus" :src="require(`../../assets/resultGame/squidgame/tow_2.png`)" alt="">
      </div>
      <div class="d-flex ">
        <span class=" m-0 text-sub symbol-line-height" :class="`-${lang}`">{{ $t('squidtoon.bonus.text3') }}</span>
      </div>

      <div class="d-flex flex-column nav-squidgame mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t("squidtoon.freespin.title") }}</h5>
        </section>
      </div>
      <div class="d-flex mt-3">
        <span class=" m-0 text-sub symbol-line-height" :class="`-${lang}`">{{ $t('squidtoon.freespin.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">{{ $t("squidtoon.freespin.text2") }}</p>
      </div>
      <div>
        <hr class="hr-freespin-centilliongod" />
      </div>
      <div class="justify-content-center d-flex flex-row">
        <div class="p-0 align-items justify-content-center d-flex flex-row ">
          <img class="mt-3 icon-combo" :src="require(`../../assets/paytable/squidgame/freespin1.png`)" alt="" />
        </div>
      </div>
      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">{{ $t("squidtoon.freespin.text3") }}</p>
      </div>
      <div>
        <hr class="hr-freespin-centilliongod" />
      </div>
      <div class="justify-content-center d-flex flex-row">
        <div class="p-0 align-items justify-content-center d-flex flex-row ">
          <img class="mt-3 icon-combo" :src="require(`../../assets/paytable/squidgame/freespin2.png`)" alt="" />
        </div>
      </div>
      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">{{ $t("squidtoon.freespin.text4") }}</p>
      </div>
      <div>
        <hr class="hr-freespin-centilliongod" />
      </div>
      <div class="justify-content-center d-flex flex-row">
        <div class="p-0 align-items justify-content-center d-flex flex-row ">
          <img class="mt-3 icon-combo" :src="require(`../../assets/paytable/squidgame/freespin3.png`)" alt="" />
        </div>
      </div>
      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub" :class="`-${lang}`">{{ $t("squidtoon.freespin.text5") }}</p>
      </div>
      <div>
        <hr class="hr-freespin-centilliongod" />
      </div>
      <div class="justify-content-center d-flex flex-row">
        <div class="p-0 align-items justify-content-center d-flex flex-row">
          <img class="mt-3 icon-combo" :src="require(`../../assets/paytable/squidgame/freespin4.png`)" alt="" />
        </div>
      </div>


      <div class="d-flex flex-column nav-squidgame mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t('bonusGameBuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-bonus" :src="require(`../../assets/paytable/squidgame/feature_buy_${imgLang}.png`)" alt="">
      </div>
      <div class="d-flex ">
        <span class=" m-0 text-sub symbol-line-height" :class="`-${lang}`">{{ $t('bonusGameBuy.text1') }}</span>
      </div>
      <div class="d-flex ">
        <span class=" m-0 text-sub symbol-line-height" :class="`-${lang}`">{{ $t('bonusGameBuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-squidgame mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("squidtoon.line.title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub symbol-line-height" :class="`-${lang}`">
          {{ $t("squidtoon.line.text1") }} <br />
          {{ $t("squidtoon.line.text2") }}
        </p>
      </div>
      <div class="justify-content-center d-flex flex-row">
        <img class="icon-paytable" :src="require(`../../assets/paytable/squidgame/pay_line.png`)" alt="" />
      </div>

      <div class="d-flex flex-column nav-squidgame mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("squidtoon.winbetline.title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub symbol-line-height " :class="`-${lang}`">
          {{ $t("squidtoon.winbetline.text1") }} <br />
          {{ $t("squidtoon.winbetline.text2") }}
        </p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-squidgame',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable,
    };
  },
};
</script>

<style>
.wild-positon {
  position: relative;
}

.nav-squidgame {
  background-color: #a11010;
  border-radius: 14px;
}

.icon-paytable {
  width: 100%;
}

.icon-paytable.-wild {
  position: absolute;
  width: 18%;
  height: 17.6vw;
}

.icon-paytable-squidgame {
  width: 65vw;
}

.bg-squidgame {
  background: #391818;
}

.icon-paytable-special {
  width: 82%;
}

.text-sub.-special {
  font-size: 4.5vw;
}

.nav-special-symbols {
  border-color: #98134D;
  border-style: solid;
  border-radius: 15px;
  border-width: thick;
}

.icon-bonus {
  width: 30%;
}

.icon-combo {
  width: 100%;
}

.bonusgame-title {
  color: #FFD700;
}

@media screen and (max-width: 768px) {
  .bg-squidgame {
    background: #000;
  }
}

.text-freespin-squidgame {
  color: #ffe463;
  font-size: 4.5vw;
}

.nav-wild {
  border-radius: 0px 14px 14px 0px;
  border-left-style: solid;
  border-right-style: solid;
  border-top-style: solid;
  border-bottom-style: solid;
  border-color: #1eaca6;
  width: 100%;
  height: 24.5vw;
  margin-left: 17vw;
}

.icon-paytable.-wild {
  margin-right: 100px;
}

.hr-freespin-squidgame {
  border: 2px solid #ffe463;
  border-radius: 5px;
  margin-top: 0vw;
}

@media screen and (max-width: 768px) {
  .header>div {
    flex-grow: 0;
    width: 33.33%;
  }
}

.symbol-line-height {
  line-height: 1.1;
}

.pading4 {
  padding: 4px;
}
</style>